'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textToHtml = undefined;

var _katex = require('katex');

var _katex2 = _interopRequireDefault(_katex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Bunny video GUIDs are RFC4122 UUIDs (e.g. 59fda450-ec6e-4f35-be3d-1c59189a04ce).
// JWPlayer media keys are 6–12 short alphanumeric (e.g. 061yF0we).
var BUNNY_GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function videoThumbUrl(id, config) {
  var bunnyHost = config && config.bunny && config.bunny.libraryHost;
  if (bunnyHost && BUNNY_GUID.test(id)) {
    return 'https://' + bunnyHost + '/' + id + '/thumbnail.jpg';
  }
  return 'https://content.jwplatform.com/thumbs/' + id + '-640.jpg';
}

function textToHtml(documentId, text, config) {
  var textClone = text.substr(0);
  var html = void 0;
  try {
    html = textClone.replace(/\n/mg, '<br/>').replace(/><br\s*\/?></mg, '><').replace(/\[image:(.*?)]/g, function (outer, inner) {
      return '<div class="document_image"><img src="' + config.storefront.staticUrl + '/' + config.storefront.documentsImagesPath + '/' + documentId + '/' + inner + '"/></div>';
    }).replace(/\[video:(.*?)]/g, function (outer, inner) {
      return '<div class="document_video"><img src="' + videoThumbUrl(inner, config) + '"/></div>';
    }).replace(/\$(.*?)\$/g, function (outer, inner) {
      return _katex2.default.renderToString(inner, { displayMode: true, throwOnError: true });
    });
  } catch (error) {
    html = error.message;
  }

  return html;
}

exports.textToHtml = textToHtml;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Parser.js
// module id = 205
// module chunks = 0